export const ILLUSTRATION_ASSET_PATH = '/assets/images/illustrations'

/**
 * Illustrations must be saved as <ILLUSTRATION_ASSET_PATH>/<name>.svg
 */
export const ILLUSTRATIONS = [
  '404',
  'archive',
  'audit-log',
  'cart',
  'cases',
  'court-system',
  'courthouse',
  'courtroom-calendar',
  'courtroom',
  'department',
  'display-screen',
  'error',
  'export',
  'foot-pedal',
  'hearings',
  'judge',
  'no-access',
  'no-errors',
  'organizations',
  'page-not-found',
  'people',
  'recorder',
  'recording-requests',
  'recording',
  'report',
  'request-stt',
  'requests',
  'search-not-found',
  'search',
  'security',
  'speech-to-text',
  'transcript',
  'users',
  'video',
  'warning-line',
] as const

export type Illustration = (typeof ILLUSTRATIONS)[number]

export const ILLUSTRATION_DEFAULT_SIZE = 144
